import React, { Component } from 'react'
import HelpIcon from 'material-ui/svg-icons/action/help'
import Warning from 'material-ui/svg-icons/alert/warning'
import Done from 'material-ui/svg-icons/action/done'
import DatePicker from 'material-ui/DatePicker'
import TimePicker from 'material-ui/TimePicker'
import FlatButton from 'material-ui/FlatButton'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'
import ReactTooltip from 'react-tooltip'

import { DateIcon, PickerContainer, TimeIcon } from './styles'
import { checkJapanese, getToken } from '../../../lib'

class Schedule extends Component {
  state = {
    time: {},
    date: {},
    dateFilled: false,
    timeFilled: false,
    submitted: false
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.startDate) {
      if (typeof nextProps.startDate === 'string') {
        this.setState({
          time: moment(nextProps.startDate).toDate(),
          date: moment(nextProps.startDate).toDate()
        })
      } else {
        this.setState({
          time: nextProps.startDate,
          date: nextProps.startDate
        })
      }
    }
  }

  handleTimeChange = (e, time) => {
    this.setState({timeFilled: true, time})
    if (this.state.date) {
      this.setState({dateFilled: true})
    }
  }

  handleDateChange = (e, date) => {
    this.setState({dateFilled: true, date})
    if (this.state.time) {
      this.setState({timeFilled: true})
    }
  }

  submitSchedule = e => {
    e.preventDefault()
    const {dateFilled, timeFilled} = this.state
    let date = moment(this.state.date).format('YYYY-MM-DD')
    let time = moment(this.state.time).format('HH:mm:ss')
    const dateTime = `${date} ${time}`
    const token = getToken()
    if (dateFilled && timeFilled) {
      this.props.updateConferenceSchedule(
        token,
        this.props.selectConferenceId,
        dateTime
      )
    }
  }

  handleClear = e => {
    e.preventDefault()
    this.setState({
      date: {},
      time: {},
      submitted: false,
      dateFilled: false,
      timeFilled: false
    })
    this.props.scheduleSubmitted(false)
  }

  render () {
    const {time, date} = this.state
    return (
      <form onSubmit={this.submitSchedule}>
        <ReactTooltip place="left" multiline effect="solid" html/>
        {this.props.isFetchingRooms ||
        this.props.isFetchingConferenceDetails ? (
          <div className="flex w-100 items-center mb3">
            Updating schedule...
          </div>
        ) : this.props.guest ? (
          <div className="flex w-100 items-center mb3">
            <FormattedMessage id="seminar.schedule"/>
          </div>
        ) : !this.props.scheduleUpdated ? (
          <div className="flex w-100 items-center mb3">
            {!(date instanceof Date) ? (
              <div className="w-10">
                <Warning color="red"/>
              </div>
            ) : (
              ''
            )}
            <div className="w-90 pr2 red">
              {!(date instanceof Date) ? (
                <FormattedMessage id="seminar.scheduleNext"/>
              ) : (
                ''
              )}
            </div>
          </div>
        ) : (
          <div className="flex w-100 items-center mb3">
            <div className="w-10">
              <Done color="green"/>
            </div>
            <div className="w-90 pr2 green">
              <FormattedMessage id="seminar.scheduleUpdated"/>
            </div>
          </div>
        )}
        <div className="flex w-100 items-center mb3">
          <div className="w-10">
            <HelpIcon
              data-tip={`
              <div
                class='pb2 custom-tooltip'>
                ${this.props.guest
                ? checkJapanese()
                  ? '開始日'
                  : 'The start date'
                : checkJapanese()
                  ? 'セミナーの開始日を設定してください。セミナーを開始した,12時間後にセミナーは自動的に終了します。'
                  : 'Set the seminar date. After setting this, you can invite the particiapnts. The seminar will automatically be ended in 12 hours of the start'}
              </div>`}
              color="#DDDDDD"
            />
          </div>
          <div className="w-90 pr2">
            <PickerContainer className="h-100">
              <DateIcon color="#DDDDDD"/>
              {this.props.guest ? (
                <div className="h-100 flex items-center">
                  {date instanceof Date ? (
                    moment(date).format('dddd MMM D, YYYY')
                  ) : (
                    <FormattedMessage id="seminar.dateNot"/>
                  )}
                </div>
              ) : (
                <DatePicker
                  ref="date"
                  hintText={<FormattedMessage id="seminar.date"/>}
                  onChange={this.handleDateChange}
                  fullWidth
                  value={date}
                  formatDate={date => moment(date).format('dddd MMM D, YYYY')}
                  mode="portrait"
                />
              )}
            </PickerContainer>
          </div>
        </div>
        <div className="flex w-100 mb3">
          <div className="w-10 pt2">
            <HelpIcon
              data-tip={`
              <div
                class='pb2 custom-tooltip'>
                ${this.props.guest
                ? checkJapanese()
                  ? '開始時刻'
                  : 'The times of the day'
                : checkJapanese()
                  ? 'セミナーの開始時刻を設定してください。'
                  : 'Set the times of the day.'}
              </div>`}
              color="#DDDDDD"
            />
          </div>
          <div className="w-90 pr2">
            <PickerContainer>
              <TimeIcon color="#DDDDDD"/>
              {this.props.guest ? (
                <div className="h-100 flex items-center">
                  {time instanceof Date ? (
                    moment(time).format('HH:mm a')
                  ) : (
                    <FormattedMessage id="seminar.notScheduled"/>
                  )}
                </div>
              ) : (
                <TimePicker
                  value={time}
                  fullWidth
                  hintText={<FormattedMessage id="seminar.time"/>}
                  onChange={this.handleTimeChange}
                />
              )}
            </PickerContainer>
          </div>
        </div>
        {!this.props.guest ? (
          <div className="flex justify-center">
            <div className="w4">
              <FlatButton
                onTouchTap={this.handleClear}
                labelStyle={{color: '#AFB8C4'}}
                label={<FormattedMessage id="seminarActions.clear"/>}
                fullWidth
              />
            </div>
            <div className="ml2 w4">
              {!this.props.scheduleUpdated ? (
                <FlatButton
                  label={<FormattedMessage id="seminar.save"/>}
                  type="submit"
                  fullWidth
                  backgroundColor="#45CE90"
                  labelStyle={{color: '#FFFFFF'}}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        ) : (
          ''
        )}
      </form>
    )
  }
}

export default Schedule



// WEBPACK FOOTER //
// ./src/components/Seminars/SeminarActions/Schedule.js